import {
  Editor as SlateEditor,
  Element as SlateElement,
  Node as SlateNode,
  Transforms,
} from 'slate';

import { SLATE_TEXT_FORMATS } from 'src/lib/slate';

const insertEmptyParagraph = (editor) =>
  Transforms.insertNodes(
    editor,
    { type: SLATE_TEXT_FORMATS.PARAGRAPH, children: [{ text: '' }] },
    { at: [0] }
  );

export const withParagraphs = (editor) => {
  const { deleteFragment, normalizeNode } = editor;

  // A delete that removes every block also drops the selection. The next keystroke then goes nowhere.
  // An outer plugin can delay normalization. The refill must not wait for it.
  editor.deleteFragment = (options) => {
    const hadSelection = Boolean(editor.selection);
    deleteFragment(options);

    if (!hadSelection || editor.selection) {
      return;
    }

    if (editor.children.length === 0) {
      insertEmptyParagraph(editor);
    }
    Transforms.select(editor, SlateEditor.start(editor, []));
  };

  editor.normalizeNode = (entry) => {
    const [node, path] = entry;

    // Slate does not refill an empty editor. Content can start and end with a void block, such as
    // an image or a divider. A delete over it removes every block. Then slate-react throws on each
    // click and key.
    if (SlateEditor.isEditor(node) && node.children.length === 0) {
      insertEmptyParagraph(editor);
      return;
    }

    // If the element is a paragraph, ensure its children are valid.
    if (SlateElement.isElement(node) && node.type === SLATE_TEXT_FORMATS.PARAGRAPH) {
      Array.from(SlateNode.children(editor, path)).forEach(([child, childPath]) => {
        if (SlateElement.isElement(child) && !editor.isInline(child)) {
          Transforms.unwrapNodes(editor, { at: childPath });
        }
      });
    }

    // Fall back to the original `normalizeNode` to enforce other constraints.
    normalizeNode(entry);
  };

  return editor;
};
